'use strict';

/**
 * Model for a album item
 *
 * @category   Model
 * @module     collection.album
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoModel = require('base/Colido.Model');

var AlbumModel = ColidoModel.extend({
    api: '/assets/photobox',

    defaults: {
        title: null,
        ts: 0,
        rfidId: 0,
        rfidEpc: '',
        storage: 0,
        source: null,
        images: [],
    },

    /**
     * Indicates, if the album has at least 1 image
     * @returns {boolean} True, if the set has an image
     */
    hasImages: function() {
        return this.getImageCount() > 0;
    },

    getImageCount: function() {
        return (this.get('images') || []).length;
    },

    getImageUrl: function(size, index) {
        size = size || '640x640';

        if (this.getImageCount() > index) {
            var image = this.getImageByIndex(index);
            if (image) {
                return image.baseUrl + size + '/' + image.fileName;
            }
        }

        return null; //@todo return placeholder image
    },

    /**
     * Returns the image by index
     * @param {int} idx Index
     * @returns {object}
     */
    getImageByIndex: function(idx) {
        var image = {};
        if (this.getImageCount() > idx) {
            image = this.get('images')[idx];
        }

        return image;
    },

    /**
     * Marks an image or removes the mark
     * @param idx
     */
    markImage: function(idx) {
        var image  = this.getImageByIndex(idx);

        if (image.hasOwnProperty('selected')) {
            image.selected = !image.selected;
        } else {
            image.selected = true;
        }

        this.set('images.' + idx, image);
        this.trigger('change', this);
    },

    isImagesSelected: function(idx) {
        var image = this.getImageByIndex(idx);

        return image.hasOwnProperty('selected') && image.selected === true;
    },

    getSelectedCount: function() {
        var count = 0;
        if (this.hasImages()) {
            _.each(this.get('images'), function(image, idx) {
                if (this.isImagesSelected(idx)) {
                    count++;
                }
            }.bind(this));
        }

        return count;
    },

    hasRfidConnection: function() {
        return this.get('rfidEpc') && this.get('rfidEpc').length > 0;
    },
});

module.exports = AlbumModel;